import React, { Component } from 'react'
import DragDropFunctions from '../../../dragDropFunctions';

export default class DivEditable extends Component {
    constructor(props) {
        super(props)

    }

    render() {

        var eleProps;
        if (this.props.elementData.props) {
            eleProps = DragDropFunctions.generatePropsForStage(this.props.elementData.props, this.props.globalVariables, "div", this.props.localVariables)
        }



        return <hr {...eleProps}>
            {this.props.children}
        </hr>



    }
}